var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {GetFirmwareDownloadLinkAsync as InvokeAsync , GetFirmwareDownloadLinkSync as InvokeSync}

async function GetFirmwareDownloadLinkAsync(LoginToken,FirmwareUUID)
{
    var GetFirmwareDownloadLinkPromise = new Promise((resolve, reject) => {
        GetFirmwareDownloadLinkSync(LoginToken,FirmwareUUID,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await GetFirmwareDownloadLinkPromise;
}

function GetFirmwareDownloadLinkSync(LoginToken,FirmwareUUID,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/User/GetFirmwareDownloadLink',                
        data  : {
            LoginToken   : LoginToken,
            FirmwareUUID : FirmwareUUID,
            AppID        : KEYS.AWS_APPID              
        },                                
    })
    .then((response)=>{        
        Callback(response.data,null);
    },(error) => {         
        Callback(null,error + ' ');
    });
}
